import moment from 'moment';
import { takeEvery } from 'redux-saga';
import { all, call, put, select, take } from 'redux-saga/effects';
import { getJSON } from '../util';

const blacklisted_pages = [
    '/checkout',
    '/confirm',
    '/signup',
];

export function* fetch(placement) {
    const [ product, user, api ] = yield select(state => [
        state.product && state.product.type,
        state.user,
        state.api.host,
    ]);

    const full_placement = product ? `${placement}-product` : placement;

    const data = yield call(getJSON, `${api}/content/promo-message`, {
        partner: 'viz',
        key: '2fae913ecc625545',
        site: /^m[.-]/.test(location.host) ? 'm.tarot.com' : 'www.tarot.com',
        placement: full_placement,
        today: moment().format('YYYY-MM-DD'),
        member_uuid: user.member_uuid || undefined,
    });

    if (data && data.length) {
        const payload = data[Math.floor(Math.random() * data.length)];
        payload.placement = placement;
        const action = user.logged_in ? 'LI Impression' : 'LO Impression';

        yield all([
            put({ type: 'promo-message:update', payload: payload }),
            put({
                type: 'ga:event',
                payload: [
                    `${placement} promo message`,
                    action,
                    payload.code,
                ],
            }),
        ]);
    }
}

export function* watchPlacement({ payload: placement }) {
    while (true) {
        yield all([
            call(fetch, placement),
            take(['user:logged-in', 'user:logged-out']),
        ]);
    }
}

export function* root() {
    if (blacklisted_pages.indexOf(location.pathname) >= 0) {
        return;
    }

    yield* takeEvery('promo-message:require', watchPlacement);
}



// WEBPACK FOOTER //
// ./app/sagas/promo-message.js